import { Slider } from '../Slider/';
import { SwitcherTab } from '../SwitcherTab';
import { ContentHeadline } from '../ContentHeadline';
import { useSliderSwitcherController } from '../../hooks/useSliderSwitcherController';
import { useWeatherState } from '../../state/useWeatherState';
import { Loader } from '../Loader';
import { useListResponseFormatted } from '../../hooks/useListResponseFormatted';

export function ContentHeader() {
	const { isWeek, isHours, setWeekTab, setHoursTab } = useSliderSwitcherController();
	const listResponse = useWeatherState((state) => state.listResponse);
	const [list] = useListResponseFormatted(isWeek, isHours, listResponse);

	return (
		<>
			<header className="content__header">
				<ContentHeadline As={'h1'} text={'Прогноз'} />
				<SwitcherTab {...{ isWeek, isHours, setWeekTab, setHoursTab }} />
			</header>

			{list === null && <Loader />}
			{list !== null && <Slider currentTab={isHours} items={list} />}
		</>
	);
}
